export const advisorOptions = state => state.options.advisor
export const extendedFilters = state => state.search.extendedFilters
export const reservationEventOptions = state => state.options.reservationEvent
export const reservationUserOptions = state => state.options.reservationUser
